import { MatDialog, MatDialogRef } from "@angular/material/dialog";

import { Proyecto } from "src/app/shared/model/gestion-proyectos/proyecto";
import { AgregarAvanceComponent } from "../seguimiento/agregar-avance/agregar-avance.component";
import { DetalleServicioComponent } from "../seguimiento/servicios/detalle/detalle-servicio.component";

/**
 * «Agregar seguimiento» de un proyecto, el mismo diálogo desde la tarjeta de
 * Gestión de Proyectos y desde la pestaña Seguimientos de la página del
 * proyecto: un servicio abre su detalle (bitácora de seguimientos) y
 * cualquier otro tipo, el registro de avance. afterClosed() da un valor
 * verdadero si se guardó algo y hay que volver a leer el proyecto.
 */
export function abrirSeguimientoDeProyecto(dialog: MatDialog, proyecto: Proyecto): MatDialogRef<unknown, unknown> {
  if (proyecto.tipo === "SERVICIO") {
    return dialog.open(DetalleServicioComponent, {
      disableClose: true,
      autoFocus: false,
      width: "720px",
      maxWidth: "96vw",
      // Ver nota en consulta-servicios.component.ts: el navbar fijo de la app queda
      // por encima del overlay de MatDialog, así que se usa un offset fijo en px
      // (no vh) para asegurar que el header del modal quede debajo del navbar.
      maxHeight: "calc(100vh - 110px)",
      position: { top: "90px" },
      panelClass: "custom-modalbox",
      data: {
        idProyecto: String(proyecto.id),
        titulo: proyecto.nombre,
        cliente: proyecto.nombreCliente,
      },
    });
  }
  return dialog.open(AgregarAvanceComponent, {
    disableClose: true,
    autoFocus: false,
    width: "65%",
    maxWidth: "860px",
    data: proyecto,
    panelClass: "custom-modalbox",
  });
}
